/* Quick view from the product card (live: Impulse quick shop modal). Loads the product page's main
   section through the Section Rendering API and shows it in a square modal. */
(function () {
  if (window.elQuickView) return;
  window.elQuickView = true;
  const html = document.documentElement;
  let modal, holder, cssLoaded = false;

  const loadScript = (src) => new Promise((res) => {
    if ([...document.scripts].some((s) => s.src.split('?')[0] === src.split('?')[0])) return res();
    const s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = res; document.head.appendChild(s);
  });

  function build() {
    modal = document.createElement('div');
    modal.className = 'modal modal--square modal--quick-shop el-quick-modal';
    modal.innerHTML = `<div class="modal__inner"><div class="modal__centered"><div class="modal__centered-content"><div class="el-quick-holder"></div></div>
      <button type="button" class="modal__close js-modal-close text-link"><svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg><span class="icon__fallback-text">Close</span></button></div></div>`;
    document.body.appendChild(modal);
    holder = modal.querySelector('.el-quick-holder');
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.closest('.js-modal-close')) close();
    });
    document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && modal.classList.contains('modal--is-active')) close(); });
  }

  function close() {
    html.classList.remove('modal-open');
    html.classList.add('modal-closing');
    modal.classList.add('modal--is-closing');
    modal.classList.remove('modal--is-active');
    setTimeout(() => { html.classList.remove('modal-closing'); modal.classList.remove('modal--is-closing'); holder.innerHTML = ''; }, 500);
  }

  async function open(url) {
    if (!modal) build();
    const base = url.split('?')[0];
    const res = await fetch(base);
    if (!res.ok) { window.location = url; return; }
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const product = doc.querySelector('[data-el-product]');
    if (!product) { window.location = url; return; }
    if (!cssLoaded) {
      (product.closest('.shopify-section') || doc).querySelectorAll('link[rel=stylesheet]').forEach((l) => {
        if (![...document.querySelectorAll('link[rel=stylesheet]')].some((x) => x.href === l.href)) document.head.appendChild(l.cloneNode());
      });
      cssLoaded = true;
    }
    const money = [...doc.querySelectorAll('script:not([src])')].find((s) => /elMoneyFormat/.test(s.textContent));
    if (money) { try { new Function(money.textContent)(); } catch (e) {} }
    const srcs = [...(product.closest('.shopify-section') || doc).querySelectorAll('script[src]')].map((s) => s.getAttribute('src'));
    product.dataset.history = 'false';
    product.querySelectorAll('[id]').forEach((el) => { el.id = 'QS-' + el.id; });
    product.querySelectorAll('[for]').forEach((el) => el.setAttribute('for', 'QS-' + el.getAttribute('for')));
    product.querySelectorAll('[form]').forEach((el) => el.setAttribute('form', 'QS-' + el.getAttribute('form')));
    product.querySelectorAll('[aria-controls]').forEach((el) => el.setAttribute('aria-controls', 'QS-' + el.getAttribute('aria-controls')));
    const h1 = product.querySelector('h1.product-single__title');
    if (h1) { const p = document.createElement('p'); p.className = h1.className; p.innerHTML = h1.innerHTML; h1.replaceWith(p); }
    holder.innerHTML = '';
    holder.appendChild(product);
    for (const src of srcs) await loadScript(src);
    html.classList.add('modal-open');
    modal.classList.add('modal--is-active');
    if (window.elInitProduct) window.elInitProduct(product);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-quick-view');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.dataset.productUrl || btn.closest('a').getAttribute('href'));
  }, true);
})();
